import {Row} from "react-bootstrap";
import CustomCard from "../../../components/CustomCard";
import React from "react";
import Title from "./Title";

export function Category(props) {
    return <>
        <Row>
            <CustomCard
                title={<Title
                    active={props.active}
                    name={props.categoryItem.category.name}
                    label={props.categoryItem.category.label}
                />}
                width={12}
                withoutPadding={props.withoutPadding}
                active={props.active}
                onClick={props.onClick}
            />
        </Row>
    </>;
}

export default Category;